<template>
    <div class="page wallet">
        <pageTitle title='充值' />
        <div class="mes">
            <p>订单号：{{g_rechargeMsg.id}}</p>
            <p>￥
                <span class="num">{{g_rechargeMsg.money}}</span>
            </p>
            <p>备注：储值卡充值</p>
        </div>
        <div class="select">
            <mu-list>
                <mu-sub-header style="font-size:0.3rem;color:#666666">支付方式</mu-sub-header>
    
                <mu-list-item title="银联支付" v-on:click="goPay(1)">
                    <mu-avatar src="../../../static/wallet/unionPay.png" slot="leftAvatar" backgroundColor="transparent" />
                    <mu-icon value="keyboard_arrow_right" slot="right" />
                </mu-list-item>
                 <mu-divider />
                <mu-list-item title="支付宝支付" v-on:click="goPay(3)" v-bind:style="{display:allowAlipay}">
                    <mu-avatar src="../../../static/wallet/aliPay.png" slot="leftAvatar" backgroundColor="transparent" />
                    <mu-icon value="keyboard_arrow_right" slot="right" />
                </mu-list-item>
                 <mu-divider v-bind:style="{display:allowAlipay}"/>
                <mu-list-item title="微信支付" v-on:click="goPay(6)" v-bind:style="{display:allowWepay}">
                    <mu-avatar src="../../../static/order/wepay.png" slot="leftAvatar" backgroundColor="transparent" />
                    <mu-icon value="keyboard_arrow_right" slot="right" />
                </mu-list-item>
                 <mu-divider v-bind:style="{display:allowWepay}" />
            </mu-list>
        </div>
    </div>
</template>


<script>

import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'
import pageTitle from "../../../components/pageTitle"

var demo = require('demo');
export default {
    computed: {
        ...mapGetters([
            'g_rechargeMsg', 'g_PayOrder', 'g_UserInfo'
        ])
    },
    activated() {
        this.allowWepay=typeof WeixinJSBridge == "undefined"?'none':'block';
        this.allowAlipay=typeof WeixinJSBridge == "undefined"?'block':'none'
    },
    created() {
        this.allowWepay=typeof WeixinJSBridge == "undefined"?'none':'block';
        this.allowAlipay=typeof WeixinJSBridge == "undefined"?'block':'none';
    },
    data() {
        return {
            // 弹出层
            TellUser: '',
            toast: false,
            // 弹出标签 选择是否
            allowWepay:typeof WeixinJSBridge == "undefined"?'none':'block',
            allowAlipay:typeof WeixinJSBridge == "undefined"?'block':'none'
        }
    },
    watch: {
        $route(to, from) {
            if (to.path == "/home/order") {

            }
        },
    },
    methods: {
        ...mapMutations([
            'setG_PayOrder',
        ]),

        goPay(val) {

            var Order = this.g_PayOrder;
            Order.OrderId = this.g_rechargeMsg.id;
            Order.Money = this.g_rechargeMsg.money;
            if (val == 1) {
                Order.PayFor = "Recharge";
                Order.PayType = "银联支付";
                this.setG_PayOrder(Order);

                // this.$router.push({ path: '/wallet/ChooseCard' });
                this.$router.push({ path: '/order/PayByUnion/ChooseCard' });

            }
            else if (val == 3) {
                Order.PayType = "支付宝支付";

                this.setG_PayOrder(Order);

                window.location.href = '/apis/Recharge/PayByAlipay?orderId=' + this.g_PayOrder.OrderId + '&cardNo=' + this.g_UserInfo.Card_no;
            }else if(val==6){
                Order.PayType = "微信支付";
                this.setG_PayOrder(Order);
                window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://i.998.com/kosmos/apis/WeChat/GetCodeReturn&response_type=code&scope=snsapi_base&state="+this.g_PayOrder.OrderId+"_1_"+this.g_rechargeMsg.money+"_I998#wechat_redirect";
            }
        },
    },
    components:{
      pageTitle
    }
}
</script>







<style lang="less">
@import "../../../assets/theme.less";
.mes {
    text-align: center;
    background-color: white;
    p:first-child {
        padding-top: 15px;
        margin-top: 0px;
        color: #999;
        font-size: 0.22rem;
    }
    p:nth-child(2) {
        font-size: 0.32rem;
        color: #333;
        .num {
            font-size: 0.72rem;
        }
    }
    p:last-child {
        font-size: 0.22rem;
        padding-bottom: 15px;
        color: #999;
    }
}

.select {
    margin-top: 10px;
    background-color: white;
    .mu-item-title {
        color: @primaryBlack;
        font-size: 0.32rem;
    }
}
</style>



// WEBPACK FOOTER //
// payStyle.vue?7a704e3a